<template lang="pug">
  div
    slot(name='children'
        v-bind:genericParentContainer='innerContainer',
        v-bind:parentContainer='outerContainer')
    //slot(name="child",
        v-bind:parentContainer='container')
      //p am sprite {{transform.id}}

    slot(v-if='rendered',name='holder',
        v-bind:holder='holder',
        v-bind:transform='transform',
        v-bind:depth='depth',
        v-bind:context='context',
        v-bind:innerContainer='innerContainer',
        v-bind:outerContainer='outerContainer',
        v-bind:displayObject='sprite.sprite')

</template>
<script>
export default {
  props:{
    transform: {
      type: Object,
      required: true
    },
    innerContainer: {
      type: Object,
      required: true
    },
    outerContainer: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    holder: {
      type: Object,
      required: true
    },
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    const sprite = new VideoTransform(this.renderTools, this.innerContainer, this.transform, component, this.holder);
    return {
      sprite,
      component,
      rendered: false
    }
  },
  components:{
  },
  mounted() {
    console.log('!!!! create video transform');
    this.sprite.events.on("loaded", () => {
      this.rendered = true;
      this.$emit("loaded");
    });
    this.renderTools.addToEnterBatch(this.sprite);
    this.renderTools.addToUpdateBatch(this.sprite);
    this.renderTools.addToRunBatch( () => {
      this.holder.addSceneObject(this.component.id, this.sprite);
    });
  },
  methods:{
  },
  beforeDestroy() {
    console.log('!!!! destroy video transform');
    this.sprite.events.off("loaded");
    this.renderTools.addToExitBatch(this.sprite);
    this.holder.removeSceneObject(this.component.id, this.sprite);
  },
  computed:{
  },
  watch:{
    'component.video'() {
      this.component.firstLoad = true;
      this.renderTools.addToUpdateBatch(this.sprite);
    }
  }
}

import Loader from '@/edit/loader.js';
import EventEmitter from 'eventemitter3';

function VideoTransform(renderTools, parentContainer, transform, data, holder) {
  this.parentContainer = parentContainer;
  this.renderTools = renderTools;
  this.transform = transform;
  this.alpha = 1;
  this.events = new EventEmitter();
  this.loading = true;
  this.data = data;
  this.sprite = new PIXI.Sprite();
  this.holder = holder;
  this.lastSprite = null;
}

VideoTransform.prototype.waiting = function () {
  if (!this.myContainer) {
    return;
  }
  if (this.destroyed) {
    return;
  }

  if (!this.loading) {
    this.events.emit("loaded");
  } else {
    this.renderTools.addToWaitBatch(this.waiting.bind(this));
  }
}

VideoTransform.prototype.enter = function () {
  this.sprite.anchor.x = 0.5;
  this.sprite.anchor.y = 0.5;
  if (this.transform.transform.anchor) {
    this.sprite.anchor.set(
      this.transform.transform.anchor.x,
      this.transform.transform.anchor.y,
    )
  }


  this.renderTools.addToWaitBatch(this.waiting.bind(this));

  const rotation = this.transform.transform.rotation;

  const scale = this.transform.transform.scale;

  //this.myContainer = new PIXI.Container();
  this.myContainer = this.parentContainer;

  this.myContainer.addChild(this.sprite);
  //this.parentContainer.addChild(this.myContainer);

  //this.myContainer.scale.x = 1;
  //this.myContainer.scale.y = 1;

}
VideoTransform.prototype.getDimensions = function () {
  console.log('getDimensions', this.data);
  const {width,height} = this.data;
  return {width,height};
  //return {width:1080,height:1920};
}
VideoTransform.prototype.justLoaded = function (texture) {
  if (this.data.thumbnail !== this.lastSprite) {
    const {width: textureWidth, height: textureHeight} = this.getDimensions();
    console.log('2 width,height', textureWidth, textureHeight);

    const aspect = textureWidth / textureHeight;
    this.data.aspect = aspect;

    this.transform.transform.localScale.x = textureWidth / (1920/16) ;
    this.transform.transform.localScale.y = textureHeight / (1080/9) ;

    const layerId = this.transform.transform.layer;
    const layer = this.renderTools.layers[layerId];
    if (layer && layer.gridx) {
      const {x,y} = this.transform.transform.localScale;
      if (x > y) {
        const aspect = x/y;
        this.transform.transform.localScale.x = layer.gridx * aspect;
        this.transform.transform.localScale.y = layer.gridy;
      } else {
        const aspect = y/x;
        this.transform.transform.localScale.x = layer.gridx;
        this.transform.transform.localScale.y = layer.gridy * aspect;
      }
      const xx = this.transform.transform.pos.x;
      const yy = this.transform.transform.pos.y;
      this.transform.transform.zIndex = Math.floor(-yy+100) * 200 + Math.floor(xx+100);
    }


    this.lastSprite = this.data.thumbnail;
    this.renderTools.addToRunBatch( () => {
      this.renderTools.addToUpdateBatch(this.holder);
      this.renderTools.addToRunBatch( () => {
        this.renderTools.addToUpdateBatch(this);
      });
    });
  }

}

VideoTransform.prototype.getSquare = function () {
  const x = this.transform.transform.scale.x;
  const y = this.transform.transform.scale.y;
  return {
    x1:-x/2,
    x2:x/2,
    y1:-y/2,
    y2:y/2
  }
}
VideoTransform.prototype.getScaleThingy = function () {
  return this.transform.transform.scale;
}
VideoTransform.prototype.update = function () {
  //if (!this.myContainer || !this.myContainer.position) {
    //return;
  //}
  //this.myContainer.x = 0;
  //this.myContainer.y = 0;
  //this.myContainer.scale.x = 1;
  //this.myContainer.scale.y = 1;

  //TODO: fix this.myContainer.alpha = this.alpha;

  if (this.transform.transform.anchor) {
    const sprite = this.sprite;
    sprite.anchor.set(
      this.transform.transform.anchor.x,
      this.transform.transform.anchor.y,
    )
  }

  console.log('currentImg', this.currentImg);
  console.log('thumbnail', this.data.thumbnail);
  if (this.currentImg !== this.data.thumbnail) {
    this.loadImage();
    this.renderTools.addToWaitBatch(this.waiting.bind(this));
  }


}
VideoTransform.prototype.exit = function () {
  this.destroyed = true;
  if (this.myContainer) {
    this.myContainer.destroy({
      children:true,
      texture:false
    })
  }

  if (this.parentContainer) {
    this.parentContainer.removeChild(this.myContainer);
  }
  this.myContainer = null;

  if (this.sprite) {
    const sprite = this.sprite;
    try {
      sprite.destroy();
    } catch (e) {
    }
  }
}


VideoTransform.prototype.getUrl = function (img) {
  return this.renderTools.makeThumbnailUrl(img);
}

VideoTransform.prototype.loadImage = function () {
  this.loading = true;
  this.renderTools.addToUpdateBatch(this);
  this.renderTools.addToWaitBatch(this.waiting.bind(this));
  const spriteToLoad = this.data.thumbnail;
  const url = this.getUrl(spriteToLoad);
  this.currentImg = this.data.thumbnail;
  console.log('loading', url);
  Loader.load(url, (err) => {
    if (this.data.thumbnail !== spriteToLoad) {
      // you've already requested a different sprite
      return;
    }
    let texture;
    this.loading = false;
    if (err) {
      console.error('error loading my sprite', err);
      texture = Loader.resources['__error'];
      this.renderTools.addError(this.transform, err);
    } else {
      texture = Loader.resources[url].texture;
    }

    const sprite = this.sprite
    if (!sprite) {
      console.warn('sprite lost for', url);
      return;
    }

    console.log('resources be', Loader.resources);
    console.log('have texture', texture);
    this.justLoaded(texture);
    sprite.texture = texture;
    this.currentImg = this.data.thumbnail;
    //const textureWidth = texture.width;
    //const textureHeight = texture.height;
    //const {width: textureWidth, height: textureHeight} = this.getDimensions();
    const textureWidth = texture.width;
    const textureHeight = texture.height;


    console.log('!!!!!!!!!!!!!!!!!!!!11', textureWidth, textureHeight);



    //sprite.scale.x =  this.renderTools.worldToScreen_x(textureWidth) * 16;
    //sprite.scale.y =  this.renderTools.worldToScreen_y(textureHeight) * 9;
    const unit = this.renderTools.worldToScreen({x:1, y:1});
    sprite.scale.x = unit.x / textureWidth;
    sprite.scale.y = unit.y / textureHeight;

    //sprite.cacheAsBitmap = true;
  });
}

</script>
